import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import UpdateTimeline from "./components/UpdateTimeline";
import TrackerBoard from "./components/TrackerBoard";
import ChannelRack from "./components/ChannelRack";
import ArchiveFeed from "./components/ArchiveFeed";
import DownloadEntry from "./components/DownloadEntry";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <TopBar />
      <main>
        <Hero />
        <UpdateTimeline />
        <TrackerBoard />
        <ChannelRack />
        <ArchiveFeed />
        <DownloadEntry />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}